var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemoveicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 27.5C0 12.3122 12.3122 0 27.5 0V0C42.6878 0 55 12.3122 55 27.5V27.5C55 42.6878 42.6878 55 27.5 55V55C12.3122 55 0 42.6878 0 27.5V27.5Z",
    fill: "url(#paint0_radial_224_5969)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5418 27.4999C43.5418 28.7656 42.5159 29.7916 41.2502 29.7916H13.7502C12.4845 29.7916 11.4585 28.7656 11.4585 27.4999C11.4585 26.2342 12.4845 25.2083 13.7502 25.2083H41.2502C42.5159 25.2083 43.5418 26.2342 43.5418 27.4999Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_224_5969",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.87889e-08 71.0417) rotate(-58.1998) scale(74.3014 99.4568)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B16B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D5FEF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveicon);
export default __webpack_public_path__ + "static/media/removeicon.ec8a228e8027deeb2ebd84e09fb81746.svg";
export { ForwardRef as ReactComponent };